module.exports = __webpack_public_path__ + "img/tips11.5b90babd.png";